import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import EmployeesTable from "./EmployeesTable"
import { useTranslation } from "react-i18next"

export default function EmployeesList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Employees")} />
        <EmployeesTable />
      </div>
    </div>
  )
}
